export default __webpack_public_path__ + "static/media/plain-sticker-bo.36bffecc.png";